import { render, staticRenderFns } from "./StudentDetailContent.vue?vue&type=template&id=41a8241e&scoped=true"
import script from "./StudentDetailContent.vue?vue&type=script&lang=js"
export * from "./StudentDetailContent.vue?vue&type=script&lang=js"
import style0 from "./StudentDetailContent.vue?vue&type=style&index=0&id=41a8241e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a8241e",
  null
  
)

export default component.exports